import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { CurrentMemberResponseSchema } from '#web-service-api/member';
import { TokensResponseSchema } from '#web-service-api/tokens';
export const WorkspaceLoginResponseSchemaOld = z.object({
    tokens: TokensResponseSchema,
    currentMember: CurrentMemberResponseSchema,
});
export class WorkspaceLoginResponseDtoOld extends createZodDto(WorkspaceLoginResponseSchemaOld) {
}
export const WorkspaceLoginResponseSchema = z.object({
    tokens: TokensResponseSchema,
});
export class WorkspaceLoginResponseDto extends createZodDto(WorkspaceLoginResponseSchema) {
}
